export default __webpack_public_path__ + "static/media/accessoriesButon.e961db3c.jpg";